<template>
    <v-container>
        <ModuleBar title="ADMINISTRAR GASTOS" icon="mdi-cash-multiple" />

        <v-card outlined class="mt-5">
            <v-card-text>
                <v-form v-model="valid" ref="formSearch">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="start_date" label="Fecha inicial" prepend-icon="mdi-calendar"
                                        readonly v-bind="attrs" v-on="on" :rules="rulesDate"></v-text-field>
                                </template>
                                <v-date-picker locale="es" v-model="start_date" @input="menu = false"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="end_date" label="Fecha final" prepend-icon="mdi-calendar"
                                        readonly v-bind="attrs" v-on="on" :rules="rulesDate"></v-text-field>
                                </template>
                                <v-date-picker locale="es" v-model="end_date" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="searchSpents" text :loading="loadingSearch" color="primary">buscar</v-btn>
            </v-card-actions>
        </v-card>

        <v-row v-if="loadingSearch" class="mt-10">
            <v-col class="text-center">
                <v-progress-circular width="2" size="60" indeterminate color="primary"></v-progress-circular>
            </v-col>
        </v-row>

        <!-- card de gastos por lider -->
        <v-card outlined class="mt-5" v-if="spents">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <h3>GASTOS AGRUPADO POR LIDERES</h3>
                    </v-col>
                </v-row>
                <v-card-title>
                    <v-spacer/>TOTAL: S/ {{ totalGeneral.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} 
                </v-card-title>
                <v-row>
                    <v-col>
                        <v-list>
                            <v-list-item-group color="primary">
                                <template v-for="spent, key in spents">                                    
                                    <v-list-item :key="key" v-if="spents" @click="openDialogSpents(spent)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ spent.names }} / {{ spent.last_names }} / {{
                                                spent.avatar }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                S/ {{ spent.total_amount.toLocaleString('es-VE', {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                                }) }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider :key="`key${key}`" v-if="key != spents.length - 1" />
                                </template>
                            </v-list-item-group>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- dialog de gastos agrupado por lider -->
        <v-dialog width="1000" v-model="dialogSpentListByEmployee" persistent>
            <v-card>
                <v-card-title>GASTO DEL LIDER: <span class="liderName"> {{ spentLider }} </span> </v-card-title>
                <v-card-text class="mt-5">
                    <div class="pl-4">DESDE: {{ new Date(this.start_date).toLocaleDateString('es-ES', {
                        day:
                            '2-digit',
                        month: '2-digit', year: 'numeric'
                    }) }}
                        HASTA: {{ new Date(this.end_date).toLocaleDateString('es-ES', {
                            day:
                                '2-digit',
                            month: '2-digit', year: 'numeric'
                        }) }} </div>
                    <v-list>
                        <template v-for="spent, key in spentByEmployee">
                            <v-list-item :key="key" v-if="spentByEmployee">
                                <v-list-item-action>
                                    <v-btn :loading="loadingDeleteSpent && keyDelete === key" icon
                                        @click="deleteSpent(spent.id, key)">
                                        <v-icon color="red">mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title> {{ spent.date }}</v-list-item-title>
                                    <v-list-item-subtitle><b> S/ {{ spent.amount.toLocaleString('es-VE', {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })
                                            }}</b></v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        Descripcion: {{ spent.description }}
                                    </v-list-item-subtitle>
                                    <!-- <v-list-item-subtitle>
                                        Registrado por: {{ spent.created_by_full_name }} / {{ spent.created_by_email }}
                                    </v-list-item-subtitle> -->
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn text color="primary" @click="openDialogSpentDetails(spent)">
                                        detalles
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="`key${key}`" v-if="key != spentByEmployee.length - 1" />
                        </template>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogSpentListByEmployee = false">cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- dialog gastos detallados por lider -->
        <v-dialog width="1000" v-model="dialogSpentDetails" persistent>
            <v-card>
                <v-card-text>
                    <spent-form :spent="spent" title="EDITAR GASTO" schema="edit" :click="click"
                        @closeDialogSpentDetails="closeDialogSpentDetails" />
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import ModuleBar from '../../components/General/ModuleBar.vue';
import SpentForm from "../../components/Forms/spentForm.vue";

export default {
    components: { ModuleBar, SpentForm },

    data() {
        return {
            menu: false,
            menu2: false,
            start_date: "2026-02-20",
            end_date: "2026-02-28",
            date: null,
            loadingSearch: false,
            spents: null,
            spent: null,
            valid: false,
            dialogSpentListByEmployee: false,
            spentByEmployee: null,
            spentLider: "",
            loadingDeleteSpent: false,
            keyDelete: null,
            dialogSpentDetails: false,
            click: 0,
            totalGeneral: 0,
            rulesDate: [
                v => !!v || "La fecha es requerida"
            ]
        }
    },

    methods: {
        searchSpents() {
            this.totalGeneral = 0;
            this.spents = null;
            if (this.valid) {
                let payload = {
                    start_date: this.start_date,
                    end_date: this.end_date
                };
                this.loadingSearch = true;
                setTimeout(() => {
                    this.$store.dispatch("findSpentByRangeAction", payload).then((res) => {
                        this.loadingSearch = false;
                        res.forEach(element => {
                            this.totalGeneral += element.total_amount;
                        });
                        this.spents = res;

                    })
                }, 500);
            } else {
                this.$refs.formSearch.validate();
            }
        },

        openDialogSpents(spent) {
            this.spentLider = spent.names + " " + spent.last_names + " / " + spent.avatar;

            let payload = {
                start_date: this.start_date,
                end_date: this.end_date,
                employee_id: spent.employee_id
            };
            this.dialogSpentListByEmployee = true;

            this.$store.dispatch("findSpentByRangeAndEmployeeAction", payload).then((res) => {
                for (let key in res) {
                    res[key].date = res[key].date.split('T')[0];
                }
                this.spentByEmployee = res;
            })
        },

        deleteSpent(spentId, key) {
            this.keyDelete = key;
            this.loadingDeleteSpent = true;

            let payload = {
                id: spentId
            };

            setTimeout(() => {
                this.$store.dispatch("deleteSpentAction", payload).then(() => {
                    this.loadingDeleteSpent = false;
                    let index = this.spentByEmployee.findIndex((x) => x.id == spentId);
                    if (index >= 0) {
                        this.spentByEmployee.splice(index, 1)
                        if (this.spentByEmployee.length == 0) {
                            this.spentByEmployee = null;
                        }
                    }
                }).catch(() => {
                    this.loadingDeleteSpent = false;
                })
            }, 500);
        },

        openDialogSpentDetails(spent) {
            this.spent = spent;
            this.click++;
            this.dialogSpentDetails = true;
        },

        closeDialogSpentDetails(data) {
            if (data) {
                let index = this.spentByEmployee.findIndex((x) => x.id == data.id);
                if (index >= 0) {
                    this.spentByEmployee.splice(index, 1, data);
                }
            }
            this.dialogSpentDetails = false;
            this.spent = null;
        }
    }
}

</script>

<style scoped>
.liderName {
    color: #1976d2;
    font-weight: bold;
    margin-left: 5px;
    font-style: italic;
}
</style>